export default {
  injuryImpact: {
    title: "Blessures",
    labels: {
      withoutPlayer: "Sans {{player}}",
    },
    empty: {
      title: "Aucune blessure disponible",
    },
  },
};
